import _extends from '@babel/runtime/helpers/extends';
import React from 'react';
import PT from 'prop-types';
import { Dropdown } from '@amzn/storm-ui';
import { W as WithFilterComponent } from './withFilter-ece78a42.js';
import { n as noop } from '../LocalModules/storm-ui-utils/dist/esm/noop-ea7cc233-62dc80e0.js';

const FilterDropdownBody = WithFilterComponent(Dropdown);
const FilterDropdown = props => /*#__PURE__*/React.createElement(FilterDropdownBody, _extends({
  focusSelected: false
}, props));
FilterDropdown.propTypes = {
  /**
   * Unique id for the search <input> element.
   */
  searchInputId: PT.string.isRequired,
  /**
   * Placeholder text for the search <input> element.
   */
  placeholder: PT.string,
  /**
   * Callback that returns results of fuzzy search on each input state change.
   */
  onFilterChange: PT.func,
  /**
   * Callback that is called when the clear button is clicked on the filter input.
   */
  onFilterClear: PT.func,
  /**
   * Callback that is called when the filter dropdown is opened.
   */
  onOpen: PT.func,
  /**
   * The list of items to be displayed in the dropdown.
   */
  items: PT.arrayOf(PT.object).isRequired,
  /**
   * Use this to provide a screen reader label for the search <input> clear button.
   */
  clearButtonLabel: PT.string,
  /**
   * Options for customizing [Fuse.js](https://fusejs.io/). Sensible defaults are already declared. Define the object properties
   * you want to search with using the `keys` option.
   */
  options: PT.shape({
    shouldSort: PT.bool,
    threshold: PT.number,
    location: PT.number,
    distance: PT.number,
    maxPatternLength: PT.number,
    minMatchCharLength: PT.number,
    keys: PT.arrayOf(PT.string)
  }),
  /**
   * Render prop for rendering components into the DOM before the filter dropdown.
   */
  preRender: PT.func,
  /**
   * Labels are required for accessibility but can be visually hidden using this prop.
   */
  hideSearchInputLabel: PT.bool,
  /**
   * Custom label for the search <input> element.
   */
  searchInputLabel: PT.string,
  /**
   * Used to render dropdown button with no background.
   */
  transparentButton: PT.bool,
  /**
   * Used to render dropdown in SecondaryView on mobile device.
   */
  mobileFullScreen: PT.bool,
  /**
   * Accepts elements to be rendered inside the close button in the SecondaryView's header.
   */
  secondaryViewCloseButtonLabel: PT.node,
  /**
   * By default, the text input will clear and onFilterClear will be called when opening the dropdown.
   * Enabling this prop will circumvent this behavior.
   */
  persistFilterState: PT.bool
};
FilterDropdown.defaultProps = {
  placeholder: '',
  onFilterChange: noop,
  onFilterClear: noop,
  onOpen: noop,
  preRender: () => null,
  clearButtonLabel: 'Clear search terms',
  options: {
    shouldSort: true,
    threshold: 0.6,
    location: 0,
    distance: 100,
    maxPatternLength: 32,
    minMatchCharLength: 1,
    keys: ['label', 'value']
  },
  hideSearchInputLabel: undefined,
  searchInputLabel: undefined,
  transparentButton: false,
  mobileFullScreen: false,
  secondaryViewCloseButtonLabel: 'Done',
  persistFilterState: false
};
var FilterDropdown$1 = FilterDropdown;

export { FilterDropdown$1 as F };
//# sourceMappingURL=FilterDropdown-7c80d690.js.map
